// extracted by mini-css-extract-plugin
export default {"img1":"styles_img1__sUld6","MuiGrid1":"styles_MuiGrid1__W8sDu"};